<template>
    <div id="geraetInFach" class="card" @click="this.switchChecked()">
        <div class="card-body">
            <h2 class="card-title">{{ geraet.name }}</h2>
            <div class="card-img-container">
                <img :src="geraet.imagePath" class="card-img">
            </div>
            <div class="checkbox-container">
                <label for="check-{{ geraet.geraetID }}">
                    <input type="checkbox" :id="'check-' + geraet.geraetID" v-model="checked"> Gerät auswählen
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: "Geraet",
    components: {},
    props: {
        geraet: Object,
        fahrzeug: Object,
        fach: Object
    },
    data() {
        return {
            checked: false,
        };
    },
    watch: {
        checked(newValue){
            /*if(newValue){
                this.createEntry(this.$props.geraet.geraetID, this.$props.fach.fachID, this.$props.fahrzeug.fahrzeugID);
            } else{
                this.deleteEntry(this.$props.geraet.geraetID, this.$props.fach.fachID, this.$props.fahrzeug.fahrzeugID);
            }*/
        }
    },
    methods: {
        async getInitialChecked(geraetID, fachID, fahrzeugID){
            try {
                const response = await axios.get(
                    'https://feuerwehr-server.org:5000/checkGeraetInFachExists',
                    {
                        params: {
                            geraetID: geraetID,
                            fachID: fachID,
                            fahrzeugID: fahrzeugID
                        }
                    }
                );
                if (response.data.message == "Entry exists") {
                    console.log('Eintrag existiert:', response.data);
                    return true; // Erfolgreiche Antwort zurückgeben
                } else {
                    console.log('Eintrag existiert nicht');
                    return false; // Kein Eintrag vorhanden
                }
            } catch (err) {
                if(err.response.data.message == "Entry does not exist"){
                    return false;
                } else{
                    console.error('Fehler bei der Anfrage:', err);
                    return false; // Im Fehlerfall false zurückgeben
                }
            }
        },
        async deleteEntry(geraetID, fachID, fahrzeugID){
            try {
                const response = await axios.delete(
                    'https://feuerwehr-server.org:5000/deleteGeraetInFachEntry',
                    {
                        data: {
                            geraetID: geraetID,
                            fachID: fachID,
                            fahrzeugID: fahrzeugID
                        }
                    }
                );
                console.log(response.data);
                return response.data; // Erfolgreiche Antwort zurückgeben
            } catch (err) {
                console.error(err);
                return false; // Im Fehlerfall false zurückgeben
            }
        },
        async createEntry(geraetID, fachID, fahrzeugID){
            try {
                const response = await axios.post(
                    'https://feuerwehr-server.org:5000/createGeraetInFachEntry',
                    {
                        geraetID: geraetID,
                        fachID: fachID,
                        fahrzeugID: fahrzeugID
                    }
                );
                console.log(response.data);
                return true; // Erfolgreiche Antwort zurückgeben
            } catch (err) {
                console.error(err);
                return false; // Im Fehlerfall false zurückgeben
            }
        },
        async switchChecked(){
            if(!this.checked){
                this.checked = await this.createEntry(this.$props.geraet.geraetID, this.$props.fach.fachID, this.$props.fahrzeug.fahrzeugID);
            } else{
                this.checked = !await this.deleteEntry(this.$props.geraet.geraetID, this.$props.fach.fachID, this.$props.fahrzeug.fahrzeugID)
            }
        }
    },
    async created() {
        this.checked = await this.getInitialChecked(this.$props.geraet.geraetID, this.$props.fach.fachID, this.$props.fahrzeug.fahrzeugID);
    },
};
</script>

<style lang="scss" scoped>
#geraetInFach {
    background-color: white;
    flex: 1 1 calc(33.333% - 20px); /* 3 Karten nebeneinander auf großen Bildschirmen */
    max-width: calc(33.333% - 20px);
    margin: 10px;
    border: solid #00000038 2px;
    border-radius: 7px;

    .card {
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 15px;
        margin: 10px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease-in-out;
        
        &:hover {
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }
    }
    
    .card-body {
        text-align: center;
    }

    .card-img-container {
        width: 100%;
        height: 200px; /* Feste Höhe für alle Bilder */
        overflow: hidden; /* Falls das Bild größer ist, wird es abgeschnitten */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .card-img {
        max-width: 100%;
        max-height: 100%;
    }

    .checkbox-container {
        margin-top: 10px;
    }
}

    @media (max-width: 1024px) {
        #geraetInFach {
            flex: 1 1 calc(50% - 20px); /* 2 Karten nebeneinander auf mittelgroßen Bildschirmen */
            max-width: calc(50% - 20px);
        }

        .card{
            margin: 0px !important;        
        }
    }

    /* Responsive Design für Smartphones */
    @media (max-width: 768px) {
        #geraetInFach {
            flex: 1 1 100%; /* 1 Karte pro Zeile auf kleinen Bildschirmen */
            max-width: 100%;
        }

        .card{
            margin-left: 0px !important;
            margin-right: 0px !important;
        }
    }
</style>
